// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* matches MUI AppBar + Toolbar default minHeight; overridden at runtime by AppLayout ResizeObserver */
:root {
  --nav-h: 56px;
}
@media (min-width: 600px) {
  :root {
    --nav-h: 64px;
  }
}

.stickySearch {
  position: sticky;
  top: var(--nav-h);
  background: white;
}

.sticky {
  position: sticky;
  top: calc(var(--nav-h) + 70px);
}

.center {
  text-align: center;
}
.right {
  text-align: right;
}
.left {
  text-align: left;
}

.divider:after,
.divider:before {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #eee;
}


.center-xy {
  width: inherit;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  position: absolute;
}

.copy-container {
  text-align: center;
}


.text-purple {
  color: #9575CD


}

.flexing {
  flex:1 1; 
  -webkit-box-flex:1; 
  -webkit-flex:1;
}

.ag-root-wrapper-body.ag-layout-normal.ag-focus-managed {
  height: 100%;
}

.swal2-title {
  font-size: 20px !important;
  font-family: 'Noto Sans Thai Looped'
}

.custom-swal2-input  {
  font-size: 25px !important;
  font-family: 'Noto Sans Thai Looped';
  text-align: center;
}

.custom-swal2-container  {
  color: red;
  font-size: 25px !important;
  font-family: 'Noto Sans Thai Looped';
  text-align: center;
}

/* --cart-tabs-h = แถบแท็บ "รายการ/รายละเอียด" บนมือถือ-แท็บเล็ต (ตั้งจาก Checkout.js)
   100dvh = ความสูงที่มองเห็นจริง — 100vh บน iPhone/iPad รวมแถบที่อยู่เว็บ ทำให้ปุ่มด้านล่างตกขอบจอ */
.cart-container { display: flex; height: calc(100vh - var(--nav-h) - var(--cart-tabs-h, 0px)); gap: 12px; padding: 12px; overflow: hidden; }
@supports (height: 100dvh) {
  .cart-container { height: calc(100dvh - var(--nav-h) - var(--cart-tabs-h, 0px)); }
}
.cart-left { flex: 1.6 1; display: flex; flex-direction: column; gap: 8px; min-width: 0; overflow: hidden; }
.cart-left-top { flex: 1 1; overflow: hidden; border: 1px solid #e0e0e0; border-radius: 8px; display: flex; flex-direction: column; }
.cart-table { flex: 1 1; overflow: hidden; }
.cart-left-bottom { flex-shrink: 0; display: flex; flex-direction: row; align-items: flex-end; gap: 12px; }
.cart-right { width: 500px; flex-shrink: 0; display: flex; flex-direction: column; overflow: hidden; }
/* แท็บเล็ตแนวนอน/จอเล็ก: แผงขวากว้าง 500px บีบตารางสินค้าจนอ่านยาก */
@media (max-width: 1279px) { .cart-right { width: 420px; } }
/* มือถือ/แท็บเล็ตแนวตั้ง (แท็บ "รายการ"): ทั้งแท็บเลื่อนเป็นหน้าเดียว — รายการสินค้ายาวตามจำนวน
   แล้วต่อด้วยโค้ดโปรโมชัน + สรุปยอดเต็มความกว้าง (เดิมสรุปยอดวางข้างโค้ดแล้วล้นขอบขวา) */
@media (max-width: 899px) {
  .cart-left { overflow-y: auto; padding: 8px; }
  .cart-left-top { flex: 0 0 auto; min-height: 160px; }
  .cart-left-bottom { flex-direction: column; align-items: stretch; }
}

/* ปรับแต่งลักษณะการแสดงของปุ่ม */
button {
  border-radius: 8px;
}

/* ปรับให้ดูดีสำหรับ text field และ select */
.MuiTextField-root, .MuiSelect-root {
  margin-bottom: 15px;
}


.swal2-container {
  z-index: 100000;
}

/* สำหรับ Chrome, Safari, Edge และ Opera */
.discount-input::-webkit-outer-spin-button,
.discount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* สำหรับ Firefox */
.discount-input {
  -moz-appearance: textfield;
}


.cell-center {
  text-align: center !important;
  vertical-align: middle;
}

/* ขนาดตัวอักษรใหญ่ขึ้น */
.large-text {
  font-size: 1.1em !important;
}

/* ตัวหนา */
.bold-text {
  font-weight: bold !important;
}

.text-blue {
  color: #0056B3 !important;
}

/* สีพื้นหลังแต่ละราคา */
.bg-price-0 {
  background-color: #b8cce4 !important;
  text-align: center;
  font-size: 1.1em;
}
.bg-price-0:hover {
  background-color: #9fb8d1 !important; /* สีเข้มขึ้น */
}

.bg-price-1 {
  background-color: #d6e3bc !important;
  text-align: center;
  font-size: 1.1em;
}
.bg-price-1:hover {
  background-color: #c4d3a9 !important;
}

.bg-price-2 {
  background-color: #fbd4b4 !important;
  text-align: center;
  font-size: 1.1em;
}
.bg-price-2:hover {
  background-color: #f7bc91 !important;
}

.bg-price-3 {
  background-color: #ccc0d9 !important;
  text-align: center;
  font-size: 1.1em;
}
.bg-price-3:hover {
  background-color: #b4a6c7 !important;
}

.bg-price-4 {
  background-color: #b6dde8 !important;
  text-align: center;
  font-size: 1.1em;
}
.bg-price-4:hover {
  background-color: #98cbdc !important;
}

.bg-cost {
  background-color: #ff0000 !important;
  color: white;
  font-weight: bold;
  text-align: center;
}
.bg-cost:hover {
  background-color: #cc0000 !important; /* แดงเข้ม */
}

/* Fix DatePicker calendar button to fit inside 36px input height */
.cart-right .MuiInputAdornment-root button {
  padding: 2px !important;
  width: 28px !important;
  height: 28px !important;
}
.cart-right .MuiInputAdornment-root .MuiSvgIcon-root {
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;;AAGA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,sGAAsG;AACtG;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;;;AAGF;;AAEA;EACE,QAAM;EACN,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;qGACqG;AACrG,kBAAkB,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC3I;EACE,kBAAkB,6DAA6D,EAAE;AACnF;AACA,aAAa,WAAS,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,gBAAgB,EAAE;AACzG,iBAAiB,SAAO,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAClI,cAAc,SAAO,EAAE,gBAAgB,EAAE;AACzC,oBAAoB,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,SAAS,EAAE;AAC1G,cAAc,YAAY,EAAE,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACrG,qEAAqE;AACrE,6BAA6B,cAAc,YAAY,EAAE,EAAE;AAC3D;yFACyF;AACzF;EACE,aAAa,gBAAgB,EAAE,YAAY,EAAE;EAC7C,iBAAiB,cAAc,EAAE,iBAAiB,EAAE;EACpD,oBAAoB,sBAAsB,EAAE,oBAAoB,EAAE;AACpE;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;;AAGA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;;AAGA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC,EAAE,eAAe;AACvD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oCAAoC,EAAE,YAAY;AACpD;;AAEA,mEAAmE;AACnE;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n/* matches MUI AppBar + Toolbar default minHeight; overridden at runtime by AppLayout ResizeObserver */\r\n:root {\r\n  --nav-h: 56px;\r\n}\r\n@media (min-width: 600px) {\r\n  :root {\r\n    --nav-h: 64px;\r\n  }\r\n}\r\n\r\n.stickySearch {\r\n  position: sticky;\r\n  top: var(--nav-h);\r\n  background: white;\r\n}\r\n\r\n.sticky {\r\n  position: sticky;\r\n  top: calc(var(--nav-h) + 70px);\r\n}\r\n\r\n.center {\r\n  text-align: center;\r\n}\r\n.right {\r\n  text-align: right;\r\n}\r\n.left {\r\n  text-align: left;\r\n}\r\n\r\n.divider:after,\r\n.divider:before {\r\n  content: \"\";\r\n  flex: 1;\r\n  height: 1px;\r\n  background: #eee;\r\n}\r\n\r\n\r\n.center-xy {\r\n  width: inherit;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%,-50%);\r\n  position: absolute;\r\n}\r\n\r\n.copy-container {\r\n  text-align: center;\r\n}\r\n\r\n\r\n.text-purple {\r\n  color: #9575CD\r\n\r\n\r\n}\r\n\r\n.flexing {\r\n  flex:1; \r\n  -webkit-box-flex:1; \r\n  -webkit-flex:1;\r\n}\r\n\r\n.ag-root-wrapper-body.ag-layout-normal.ag-focus-managed {\r\n  height: 100%;\r\n}\r\n\r\n.swal2-title {\r\n  font-size: 20px !important;\r\n  font-family: 'Noto Sans Thai Looped'\r\n}\r\n\r\n.custom-swal2-input  {\r\n  font-size: 25px !important;\r\n  font-family: 'Noto Sans Thai Looped';\r\n  text-align: center;\r\n}\r\n\r\n.custom-swal2-container  {\r\n  color: red;\r\n  font-size: 25px !important;\r\n  font-family: 'Noto Sans Thai Looped';\r\n  text-align: center;\r\n}\r\n\r\n/* --cart-tabs-h = แถบแท็บ \"รายการ/รายละเอียด\" บนมือถือ-แท็บเล็ต (ตั้งจาก Checkout.js)\r\n   100dvh = ความสูงที่มองเห็นจริง — 100vh บน iPhone/iPad รวมแถบที่อยู่เว็บ ทำให้ปุ่มด้านล่างตกขอบจอ */\r\n.cart-container { display: flex; height: calc(100vh - var(--nav-h) - var(--cart-tabs-h, 0px)); gap: 12px; padding: 12px; overflow: hidden; }\r\n@supports (height: 100dvh) {\r\n  .cart-container { height: calc(100dvh - var(--nav-h) - var(--cart-tabs-h, 0px)); }\r\n}\r\n.cart-left { flex: 1.6; display: flex; flex-direction: column; gap: 8px; min-width: 0; overflow: hidden; }\r\n.cart-left-top { flex: 1; overflow: hidden; border: 1px solid #e0e0e0; border-radius: 8px; display: flex; flex-direction: column; }\r\n.cart-table { flex: 1; overflow: hidden; }\r\n.cart-left-bottom { flex-shrink: 0; display: flex; flex-direction: row; align-items: flex-end; gap: 12px; }\r\n.cart-right { width: 500px; flex-shrink: 0; display: flex; flex-direction: column; overflow: hidden; }\r\n/* แท็บเล็ตแนวนอน/จอเล็ก: แผงขวากว้าง 500px บีบตารางสินค้าจนอ่านยาก */\r\n@media (max-width: 1279px) { .cart-right { width: 420px; } }\r\n/* มือถือ/แท็บเล็ตแนวตั้ง (แท็บ \"รายการ\"): ทั้งแท็บเลื่อนเป็นหน้าเดียว — รายการสินค้ายาวตามจำนวน\r\n   แล้วต่อด้วยโค้ดโปรโมชัน + สรุปยอดเต็มความกว้าง (เดิมสรุปยอดวางข้างโค้ดแล้วล้นขอบขวา) */\r\n@media (max-width: 899px) {\r\n  .cart-left { overflow-y: auto; padding: 8px; }\r\n  .cart-left-top { flex: 0 0 auto; min-height: 160px; }\r\n  .cart-left-bottom { flex-direction: column; align-items: stretch; }\r\n}\r\n\r\n/* ปรับแต่งลักษณะการแสดงของปุ่ม */\r\nbutton {\r\n  border-radius: 8px;\r\n}\r\n\r\n/* ปรับให้ดูดีสำหรับ text field และ select */\r\n.MuiTextField-root, .MuiSelect-root {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n\r\n.swal2-container {\r\n  z-index: 100000;\r\n}\r\n\r\n/* สำหรับ Chrome, Safari, Edge และ Opera */\r\n.discount-input::-webkit-outer-spin-button,\r\n.discount-input::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* สำหรับ Firefox */\r\n.discount-input {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n\r\n.cell-center {\r\n  text-align: center !important;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* ขนาดตัวอักษรใหญ่ขึ้น */\r\n.large-text {\r\n  font-size: 1.1em !important;\r\n}\r\n\r\n/* ตัวหนา */\r\n.bold-text {\r\n  font-weight: bold !important;\r\n}\r\n\r\n.text-blue {\r\n  color: #0056B3 !important;\r\n}\r\n\r\n/* สีพื้นหลังแต่ละราคา */\r\n.bg-price-0 {\r\n  background-color: #b8cce4 !important;\r\n  text-align: center;\r\n  font-size: 1.1em;\r\n}\r\n.bg-price-0:hover {\r\n  background-color: #9fb8d1 !important; /* สีเข้มขึ้น */\r\n}\r\n\r\n.bg-price-1 {\r\n  background-color: #d6e3bc !important;\r\n  text-align: center;\r\n  font-size: 1.1em;\r\n}\r\n.bg-price-1:hover {\r\n  background-color: #c4d3a9 !important;\r\n}\r\n\r\n.bg-price-2 {\r\n  background-color: #fbd4b4 !important;\r\n  text-align: center;\r\n  font-size: 1.1em;\r\n}\r\n.bg-price-2:hover {\r\n  background-color: #f7bc91 !important;\r\n}\r\n\r\n.bg-price-3 {\r\n  background-color: #ccc0d9 !important;\r\n  text-align: center;\r\n  font-size: 1.1em;\r\n}\r\n.bg-price-3:hover {\r\n  background-color: #b4a6c7 !important;\r\n}\r\n\r\n.bg-price-4 {\r\n  background-color: #b6dde8 !important;\r\n  text-align: center;\r\n  font-size: 1.1em;\r\n}\r\n.bg-price-4:hover {\r\n  background-color: #98cbdc !important;\r\n}\r\n\r\n.bg-cost {\r\n  background-color: #ff0000 !important;\r\n  color: white;\r\n  font-weight: bold;\r\n  text-align: center;\r\n}\r\n.bg-cost:hover {\r\n  background-color: #cc0000 !important; /* แดงเข้ม */\r\n}\r\n\r\n/* Fix DatePicker calendar button to fit inside 36px input height */\r\n.cart-right .MuiInputAdornment-root button {\r\n  padding: 2px !important;\r\n  width: 28px !important;\r\n  height: 28px !important;\r\n}\r\n.cart-right .MuiInputAdornment-root .MuiSvgIcon-root {\r\n  font-size: 18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
